import React from 'react'
import {Icon} from '@chakra-ui/react'

const UpDownIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.1387 38.3333V3.95831H29.1387V38.3333H26.1387Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8614 1.66663L13.8613 36.0416L10.8613 36.0416L10.8614 1.66663L13.8614 1.66663Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.6385 1.83698L37.8658 12.0643L35.7445 14.1856L27.6385 6.07962L19.5325 14.1856L17.4111 12.0643L27.6385 1.83698Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.13379 27.9357L4.25511 25.8143L12.3611 33.9203L20.4671 25.8143L22.5884 27.9357L12.3611 38.163L2.13379 27.9357Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default UpDownIcon
